var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsumption(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.334 5.0013V7.01797C18.334 8.33464 17.5006 9.16797 16.184 9.16797H13.334V3.34297C13.334 2.41797 14.0923 1.66797 15.0173 1.66797C15.9257 1.6763 16.759 2.04297 17.359 2.64297C17.959 3.2513 18.334 4.08464 18.334 5.0013Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 5.83464V17.5013C1.66602 18.193 2.44933 18.5846 2.99933 18.168L4.42435 17.1013C4.75768 16.8513 5.22435 16.8846 5.52435 17.1846L6.90766 18.5763C7.23266 18.9013 7.76603 18.9013 8.09103 18.5763L9.49103 17.1763C9.78269 16.8846 10.2494 16.8513 10.5744 17.1013L11.9994 18.168C12.5494 18.5763 13.3327 18.1846 13.3327 17.5013V3.33464C13.3327 2.41797 14.0827 1.66797 14.9993 1.66797H5.83268H4.99935C2.49935 1.66797 1.66602 3.15964 1.66602 5.0013V5.83464Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5H10",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 10.832H9.375",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsumption);
export default __webpack_public_path__ + "static/media/consumption.72e3b97c9a2917de8b6f754a12a36ea2.svg";
export { ForwardRef as ReactComponent };